export default [
  {
    path: '/duty_management',
    component: (resolve) => require(['@/views/duty_manage/index'], resolve),
    hidden: true,
    meta: {
      title: '执勤管理',
      code: 'duty_management',
    },
    children: [
      {
        path: 'task_management',
        component: (resolve) => require(['@/views/duty_manage/task_management/index.vue'], resolve),
        meta: {
          title: '任务管理',
          code: 'task_management',
        },
      },
      {
        path: 'task_details',
        component: (resolve) => require(['@/views/duty_manage/task_management/taskDetails.vue'], resolve),
        meta: {
          title: '任务详情',
          code: 'task_details',
        },
      },
      {
        path: 'duty_personnel_manage',
        component: (resolve) => require(['@/views/duty_manage/duty_personnel_manage/index.vue'], resolve),
        meta: {
          title: '执勤人员管理',
          code: 'duty_personnel_manage',
        },
      },
      {
        path: 'duty_sign_manage',
        component: (resolve) => require(['@/views/duty_manage/duty_sign_manage/index.vue'], resolve),
        meta: {
          title: '签到管理',
          code: 'duty_sign_manage',
        },
      },
      {
        path: 'duty_task_record',
        component: (resolve) => require(['@/views/duty_manage/duty_task_record/index.vue'], resolve),
        meta: {
          title: '执勤任务记录',
          code: 'duty_task_record',
        },
      },
      {
        path: 'duty_abnormal_details',
        component: (resolve) => require(['@/views/duty_manage/duty_abnormal_details/index.vue'], resolve),
        meta: {
          title: '执勤异常',
          code: 'duty_abnormal_details',
        },
      },
    ]
  }
]


// WEBPACK FOOTER //
// ./src/router/module/duty_management.js